{
  "comment": "Mission 1, The Manifest (spec §4; S12 owns). Offered at tier 2 (the decode of the guaranteed first core, S2's evacuation.c9_decode lead); the giver is that log, so the offer contact is the Mutual scrapyard that decodes it. Steps, none with a deadline: find (scan the Column Nine field; the Tethys Asset Recovery crew is spawned there through spawnStoryShip when the mission goes active (S37: story/world12.json m1.acceptCommands, issued once by the story link), never from ambient traffic; the queue-order signature beat is world content, S37), recover (the lead hauler's flight recorder, a sealed story item), decode (dock at the Mutual scrapyard; fallbacks per comms/common.json contacts.m1Decode: any Mutual station, then a Holdfast workshop; S30 maps a dock at any of them to these keys). The bounty fork after recover is the first of the two cash-for-silence forks (spec §1 rule 3): every choice's cost is a comms node in comms/m1.json shown before commit. sell_cash and sell_waived both keep a partial copy (× 0.33), set manifest_sold, take the manifestSold clock alert and pay leverage.ts's capped offer through the named payouts m1BountyCash / m1BountyWaived (src/story/m12.ts m12Payouts; waived = the next payments waived while leased, cash otherwise). The keep choice sets manifest_recovered. The decode costs the scrapyard fee (credits −1500, skipped with a warning if the wallet can't cover it) and pays Mutual +15 either way (the first Mutual contact; a seller decodes the partial copy). Lasting trace: the world flag story.columnNine = memorial (kept) or stripped (sold). Echoes and callbacks are S11's, keyed on the flags. Site, station and ship keys are resolved by the story link (S30, S37).",
  "id": "m1",
  "offer": {
    "tier": 2,
    "contact": "mutualScrapyard",
    "comms": "m1.lead"
  },
  "steps": [
    {
      "id": "find",
      "verb": "scan",
      "target": {
        "kind": "poi",
        "ref": "column-nine"
      },
      "onDone": {
        "comms": "m1.crew"
      }
    },
    {
      "id": "recover",
      "verb": "recover",
      "target": {
        "kind": "item",
        "ref": "column_nine_recorder"
      },
      "item": "column_nine_recorder",
      "onDone": {
        "items": [
          {
            "id": "column_nine_recorder",
            "state": "held"
          }
        ]
      }
    },
    {
      "id": "decode",
      "verb": "dock",
      "target": {
        "kind": "station",
        "ref": "mutual-scrapyard"
      },
      "fallback": {
        "kind": "station",
        "ref": "holdfast-workshop"
      },
      "onDone": {
        "credits": -1500,
        "standings": [
          {
            "faction": "mutual",
            "delta": 15
          }
        ],
        "comms": "m1.decoded"
      }
    }
  ],
  "forks": [
    {
      "id": "bounty",
      "afterStep": "recover",
      "choices": [
        {
          "id": "keep",
          "cost": "m1.bounty.keep",
          "outcome": {
            "setFlags": [
              "manifest_recovered"
            ],
            "commands": [
              {
                "type": "setWorldFlag",
                "key": "story.columnNine",
                "value": "memorial"
              }
            ]
          }
        },
        {
          "id": "sell_cash",
          "cost": "m1.bounty.sell_cash",
          "outcome": {
            "items": [
              {
                "id": "column_nine_recorder",
                "state": "copy",
                "where": "assetRecovery"
              }
            ],
            "setFlags": [
              "manifest_sold"
            ],
            "alerts": [
              "manifestSold"
            ],
            "standings": [
              {
                "faction": "tethys",
                "delta": 10
              }
            ],
            "payout": "m1BountyCash",
            "commands": [
              {
                "type": "setWorldFlag",
                "key": "story.columnNine",
                "value": "stripped"
              }
            ],
            "comms": "m1.sold"
          }
        },
        {
          "id": "sell_waived",
          "cost": "m1.bounty.sell_waived",
          "outcome": {
            "items": [
              {
                "id": "column_nine_recorder",
                "state": "copy",
                "where": "assetRecovery"
              }
            ],
            "setFlags": [
              "manifest_sold"
            ],
            "alerts": [
              "manifestSold"
            ],
            "standings": [
              {
                "faction": "tethys",
                "delta": 10
              }
            ],
            "payout": "m1BountyWaived",
            "commands": [
              {
                "type": "setWorldFlag",
                "key": "story.columnNine",
                "value": "stripped"
              }
            ],
            "comms": "m1.sold"
          }
        }
      ]
    }
  ],
  "trace": "trace.column_nine"
}
